import React, { useEffect, useState } from 'react';
import { FaTrash, FaTimes, FaExclamationTriangle } from 'react-icons/fa';
import './DeleteConfirmModal.css';

const ANIMATION_MS = 180;

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm }) => {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const [isVisible, setIsVisible] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      requestAnimationFrame(() => setIsVisible(true));
      return undefined;
    }

    setIsVisible(false);
    const timeout = setTimeout(() => setShouldRender(false), ANIMATION_MS);
    return () => clearTimeout(timeout);
  }, [isOpen]);

  useEffect(() => {
    if (!shouldRender) return undefined;

    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [shouldRender, onClose]);

  if (!shouldRender) return null;

  return (
    <div
      className={`delete-confirm-overlay ${isVisible ? 'open' : 'closing'}`}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-confirm-title"
    >
      <div className={`delete-confirm-modal ${isVisible ? 'open' : 'closing'}`} onClick={(e) => e.stopPropagation()}>
        <div className="delete-confirm-icon-wrap">
          <FaExclamationTriangle />
        </div>
        <h2 id="delete-confirm-title">Delete Property</h2>
        <p>Are you sure you want to delete this property? This action cannot be undone.</p>
        <div className="delete-confirm-actions">
          <button type="button" className="delete-confirm-cancel" onClick={onClose}>
            <FaTimes />
            <span>Cancel</span>
          </button>
          <button type="button" className="delete-confirm-delete" onClick={onConfirm}>
            <FaTrash />
            <span>Delete</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
